cloneRegExp